import type { Location } from '@/models/locationModel';

export interface Stay22ResolvedLocation {
  lat?: number;
  lng?: number;
  address?: string;
}

function resolveStay22AddressFromPlace(params: {
  locationData?: Partial<Location> | null;
  fallbackAddress?: string;
  fallbackName?: string;
}): string | undefined {
  return (
    params.fallbackAddress?.trim() ||
    params.locationData?.a3_intl_address?.trim() ||
    params.locationData?.address?.trim() ||
    params.fallbackName?.trim() ||
    params.locationData?.name?.trim() ||
    undefined
  );
}

/** Resolves Stay22 location params from place data (prefer lat/lng; keep address for Allez hotel matching). */
export function resolveStay22LocationFromPlace(params: {
  locationData?: Partial<Location> | null;
  fallbackAddress?: string;
  fallbackName?: string;
}): Stay22ResolvedLocation {
  const address = resolveStay22AddressFromPlace(params);
  const coords = params.locationData?.geoposition?.coordinates;
  const lat = coords?.[1];
  const lng = coords?.[0];

  if (typeof lat === 'number' && typeof lng === 'number' && !Number.isNaN(lat) && !Number.isNaN(lng)) {
    return address ? { lat, lng, address } : { lat, lng };
  }

  return address ? { address } : {};
}
